/**
 * Copyright 2022 Phenix Real Time Solutions, Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import config from '../../../config';

const channel = (state = {
  alias: config.channel.primaryAlias,
  mediaStream: null,
  joinChannelPending: true
}, action) => {
  switch (action.type) {
    case 'JOIN_CHANNEL':
      return {
        ...state,
        channelDoesNotExist: false
      };
    case 'JOIN_NON_EXISTENT_CHANNEL':
      return {
        ...state,
        channelDoesNotExist: true,
        joinChannelPending: false
      };
    case 'CHANNEL_ACCESS_DENIED':
      return {
        ...state,
        accessDenied: true,
        joinChannelPending: false
      };
    case 'UNSUPPORTED_FEATURE':
      return {
        ...state,
        featureNotSupported: true
      };
    case 'STREAM_CHANGED':
      return {
        ...state,
        mediaStream: action.mediaStream,
        accessDenied: false,
        joinChannelPending: false,
        featureNotSupported: false
      };
    case 'STREAM_ENDED':
      return {
        ...state,
        mediaStream: removeIfTheSameStream(action.mediaStream, state.mediaStream)
      };
    case 'DRM_ERROR':
      return {
        ...state,
        drmError: action.error
      };
    case 'NO_TOKEN_ERROR':
      return {
        ...state,
        noTokenError: action.error
      };
    default:
      return {...state};
  }
};

function removeIfTheSameStream(streamA, streamB) {
  // The stream is null after it ended
  if (!streamA || streamA && streamB && streamA.getStreamId() === streamB.getStreamId()) {
    return null;
  }

  return streamB;
}

export default channel;